import React, { useState, useEffect } from 'react';
import {
    Grid,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TableContainer,
    Paper,
    Box,
    IconButton,
    Tooltip
} from "@mui/material";
import Pagination from '@mui/lab/Pagination';
import moment from "moment";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SelectCMP from "react-select";
import * as actions from "./actions";
import { toastSuccess } from '../../utils';

export default function MusilinksHistory(props) {
    const { setLoader = () => { } } = props;

    const [history, setHistory] = useState([]);
    const [filters, setFilters] = useState({
        limit: 50,
        offset: 0,
        page: 1
    });
    const [totalCount, setTotalCount] = useState(0);
    const [excludedUsers, setExcludedUsers] = useState([]);
    const [userOptions, setUserOptions] = useState([]);

    useEffect(() => {
        actions.getMusilinksUsersAdmin().then(res => {
            const users = (Array.isArray(res.body) && res.body) || [];
            setUserOptions(users.map(u => ({ label: u.username, value: u.username })));
        }).catch(() => { });
    }, []);

    useEffect(() => {
        fetchHistory();
    }, [filters, excludedUsers]);

    const fetchHistory = () => {
        setLoader(true);
        const excludeUsers = excludedUsers.map(u => u.value).join(",");
        actions.getMusilinksHistoryAdmin({ ...filters, excludeUsers }).then(res => {
            setLoader(false);
            setHistory((Array.isArray(res.body) && res.body) || []);
            setTotalCount(res.total);
        }).catch(err => {
            setLoader(false);
        });
    };

    const onPageChange = (event, page) => {
        const offset = (page - 1) * filters.limit;
        setFilters({ ...filters, page, offset });
    };

    const onExcludeChange = (selected) => {
        setExcludedUsers(selected || []);
        setFilters(prev => ({ ...prev, page: 1, offset: 0 }));
    };

    const onCopy = (text) => {
        navigator.clipboard.writeText(text);
        toastSuccess('Copied to clipboard');
    };

    const totalPages = Math.ceil(Number(totalCount) / filters.limit);

    return (
        <Box sx={{ backgroundColor: 'background.paper', width: '100%' }}>
            <Grid container>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px', marginBottom: '20px' }}>
                        <Box sx={{ minWidth: 450 }}>
                            <SelectCMP
                                isMulti
                                options={userOptions}
                                value={excludedUsers}
                                onChange={onExcludeChange}
                                placeholder="Exclude Users"
                            />
                        </Box>
                        <span style={{ fontWeight: 'bold', fontSize: '20px' }}>
                            Total Searches: {totalCount}
                        </span>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow style={{ background: "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)" }}>
                                    <TableCell className="color-white">S.No</TableCell>
                                    <TableCell className="color-white">Username</TableCell>
                                    <TableCell className="color-white">Searched Term</TableCell>
                                    <TableCell className="color-white">Searched At</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    history.length ? history.map((item, index) => {
                                        const isLink = item.search && item.search.includes('https');
                                        return (
                                            <TableRow key={item.history_id || index}>
                                                <TableCell>{((filters.page - 1) * filters.limit) + (index + 1)}</TableCell>
                                                <TableCell>{item.username}</TableCell>
                                                <TableCell style={{ maxWidth: 600, wordBreak: 'break-all' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                        <span>{item.search}</span>
                                                        <Tooltip title="Copy">
                                                            <IconButton size="small" onClick={() => onCopy(item.search)}>
                                                                <ContentCopyIcon sx={{ fontSize: 16 }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        {isLink && (
                                                            <Tooltip title="Open in new tab">
                                                                <IconButton size="small" onClick={() => window.open(item.search, '_blank')}>
                                                                    <OpenInNewIcon sx={{ fontSize: 16 }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </Box>
                                                </TableCell>
                                                <TableCell>{moment(item.searched_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                            </TableRow>
                                        );
                                    }) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">No records found</TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                        <Pagination
                            count={totalPages}
                            showFirstButton
                            showLastButton
                            onChange={onPageChange}
                            page={filters.page || 0}
                        />
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    );
}
